import React from "react";
import { Link } from "react-router-dom";
import EntityPage from "@/components/EntityPage";
import { useRefData } from "@/context/RefDataContext";

export default function AssetsPage() {
  const ref = useRefData();

  const columns = [
    {
      key: "code",
      label: "Asset ID",
      render: (a) => (
        <Link
          to={`/assets/${a.id}`}
          className="font-mono text-xs text-sky-400 hover:underline"
          data-testid={`assets-code-${a.id}`}
        >
          {a.code}
        </Link>
      ),
    },
    {
      key: "asset_type",
      label: "Type",
      render: (a) => (
        <Link
          to={`/assets/${a.id}`}
          className="text-white hover:text-sky-300 transition-colors"
          data-testid={`assets-type-${a.id}`}
        >
          {a.asset_type}
        </Link>
      ),
    },
    { key: "oem_name", label: "OEM" },
    { key: "model_number", label: "Model" },
    { key: "serial_number", label: "Serial #", render: (a) => <span className="font-mono text-xs text-zinc-300">{a.serial_number || "—"}</span> },
    { key: "purchase_date", label: "Purchased", render: (a) => <span className="text-zinc-400 text-xs">{a.purchase_date || "—"}</span> },
  ];

  const fields = [
    { key: "asset_type", label: "Asset Type", type: "select", optionsRef: "asset_types", required: true },
    { key: "oem_name", label: "OEM Name" },
    { key: "model_number", label: "Model Number" },
    { key: "serial_number", label: "Serial Number" },
    { key: "project_id", label: "CDARK", type: "select", optionsRef: "projects" },
    { key: "purchase_date", label: "Purchase Date", type: "date" },
    { key: "purchase_invoice_number", label: "Purchase Invoice #" },
    { key: "vendor_relationship_number", label: "Vendor Relationship #" },
    { key: "license_expiry_date", label: "License Expiry", type: "date" },
    { key: "commissioning_date", label: "Commissioning Date", type: "date" },
    { key: "delivery_challan_number", label: "Delivery Challan #" },
    { key: "description", label: "Description", type: "textarea", full: true },
    { key: "files", label: "Attachments", type: "files", full: true },
  ];

  const initial = {
    asset_type: "",
    oem_name: "",
    model_number: "",
    serial_number: "",
    project_id: "",
    purchase_date: "",
    purchase_invoice_number: "",
    vendor_relationship_number: "",
    license_expiry_date: "",
    commissioning_date: "",
    delivery_challan_number: "",
    description: "",
    files: [],
  };

  return (
    <EntityPage
      title="Assets"
      subtitle="Physical and digital items the organisation owns or leases."
      testidPrefix="assets"
      endpoint="/assets"
      columns={columns}
      fields={fields}
      initialForm={initial}
      referenceData={ref}
      filters={[
        {
          key: "no_cdark",
          label: "Unallocated",
          predicate: (a) => !a.project_id,
        },
      ]}
    />
  );
}
